import { Component } from '@angular/core';

@Component({
  selector: 'svc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  year = new Date().getFullYear();
}
